
import React, { useEffect, useRef, useState } from 'react';
import "../../styles/UserDashboard/EnergyEfficiencyOverview.scss"
import battery from "../../images/battery.png"
import * as echarts from 'echarts';
import { setEnergyGoal as setEnergyGoalAPI, getHistoricalBaseLine } from '../../apis/EnergyEfficient/EfficientApi';
// import { setEnergyGoal, getHistoricalBaseLine } from '../../apis/EnergyEfficient/EfficientApi';
import { setEnergyGoal as setEnergyGoalBlockchain } from '../../context/energyEfficiency/efficiencyIntegration'; // Import blockchain function
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
  get,
} from "firebase/database";
import { getUserInfo } from "../../apis/General/users";
import { useQuery } from "@tanstack/react-query";
import { getSetGoal } from '../../apis/EnergyEfficient/EfficientApi';
import { useWallet } from '../../context/energyEfficiency/wallet';

// Energy Insights Hook
const useEnergyInsights = (allEnergyData, energyGoalKw, historicalBaselineKw, goalDurationMonths = 6) => {
  const React = require('react');
  return React.useMemo(() => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    const currentDay = now.getDate();
    const currentWeekStart = new Date(now.setDate(now.getDate() - now.getDay())).getTime();
    const lastWeekStart = new Date(now.setDate(now.getDate() - 7 - now.getDay())).getTime();

    const todayStart = new Date(currentYear, currentMonth, currentDay).getTime();
    const yesterdayStart = new Date(currentYear, currentMonth, currentDay - 1).getTime();

    let todayUsage = 0;
    let yesterdayUsage = 0;
    let currentMonthUsage = 0;
    let currentWeekUsage = 0;
    let lastWeekUsage = 0;
    let energyMeterUsage = 0;

    const hourlyUsage = {};

    allEnergyData.forEach((entry) => {
      const entryDate = new Date(entry.unix_ms);
      const entryMonth = entryDate.getMonth();
      const entryYear = entryDate.getFullYear();
      const entryDay = entryDate.getDate();

      energyMeterUsage += entry.energyConsumptionKw;

      if (entryDate.getTime() >= todayStart) {
        todayUsage += entry.energyConsumptionKw;
        const hour = entryDate.getHours();
        hourlyUsage[hour] = (hourlyUsage[hour] || 0) + entry.energyConsumptionKw;
      }
      if (entryDate.getTime() >= yesterdayStart && entryDate.getTime() < todayStart) {
        yesterdayUsage += entry.energyConsumptionKw;
      }
      if (entryMonth === currentMonth && entryYear === currentYear) {
        currentMonthUsage += entry.energyConsumptionKw;
      }
      if (entry.unix_ms >= currentWeekStart) {
        currentWeekUsage += entry.energyConsumptionKw;
      }
      if (entry.unix_ms >= lastWeekStart && entry.unix_ms < currentWeekStart) {
        lastWeekUsage += entry.energyConsumptionKw;
      }
    });

    const todayVsYesterdayPercentage = yesterdayUsage > 0 ? ((todayUsage - yesterdayUsage) / yesterdayUsage) * 100 : 0;

    let peakHour = "N/A";
    let maxHourlyUsage = 0;
    for (const hour in hourlyUsage) {
      if (hourlyUsage[hour] > maxHourlyUsage) {
        maxHourlyUsage = hourlyUsage[hour];
        peakHour = `${Number.parseInt(hour) % 12 || 12}:00 ${Number.parseInt(hour) < 12 ? "AM" : "PM"}`;
      }
    }

    const energySavedPercentage = historicalBaselineKw > 0 ? ((historicalBaselineKw - currentMonthUsage) / historicalBaselineKw) * 100 : 0;
    const goalTrackerPercentage = lastWeekUsage > 0
  ? ((currentWeekUsage - lastWeekUsage) / lastWeekUsage) * 100
  : 0;

    const remainingGoal = Math.max(0, energyGoalKw - energyMeterUsage);
    const dailyAverageConsumption = energyMeterUsage / ((Date.now() - new Date(currentYear, 0, 1).getTime()) / (1000 * 60 * 60 * 24));
    const daysRemaining = dailyAverageConsumption > 0 ? remainingGoal / dailyAverageConsumption : 0;
    const energyMeterMonthsLeft = daysRemaining / 30.44;

    return {
      energySavedPercentage: Number.parseFloat(energySavedPercentage.toFixed(1)),
      todayUsage: Number.parseFloat(todayUsage.toFixed(1)),
      todayVsYesterdayPercentage: Number.parseFloat(todayVsYesterdayPercentage.toFixed(1)),
      peakUsageTime: peakHour,
      peakUsageValue: Number.parseFloat(maxHourlyUsage.toFixed(1)),
      goalTrackerValue: Number.parseFloat(currentWeekUsage.toFixed(1)),
      goalTrackerPercentage: Number.parseFloat(goalTrackerPercentage.toFixed(1)),
      energyMeterUsage: Number.parseFloat(energyMeterUsage.toFixed(1)),
      energyMeterMonthsLeft: Number.parseFloat(energyMeterMonthsLeft.toFixed(1)),
    };
  }, [allEnergyData, energyGoalKw, historicalBaselineKw, goalDurationMonths]);
};

function EfficiencyCard() {
  const navigate = useNavigate()
  const chartRef = useRef(null);
  const [showGoalModal, setShowGoalModal] = useState(false);
    const [energyGoalKw, setEnergyGoalValue] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [deviceId, setDeviceId] = useState()
  const [account, setAccount] = useState(null);
  const [balance, setBalance] = useState(null);
  const [walleterror, setWalletError] = useState(null);
  const [blockchainTxHash, setBlockchainTxHash] = useState(null); // Track blockchain transaction

  const { handleWalletConnect, signer } = useWallet();

  // const connectWallet = async () => {
  //   try {
  //     await handleWalletConnect(setAccount, setBalance);
  //     setWalletError(null);
  //   } catch (error) {
  //     setWalletError("Failed to connect wallet. Please ensure MetaMask is installed and set to Optimism Sepolia.");
  //   }
  // };

  const auth = useSelector((state) => state.auth);
  const userId = auth?.userInfo?.id 
  console.log(auth)
  console.log(userId)
  
  const getDeviceId = async()=>{
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    setDeviceId(response?.data?.message?.registeredDevices[0].deviceId)
  }

  const db = getDatabase();
  
  const getFireBaseData = async () => {
    const newRef = ref(db, "dev-energy-sharing-table");
    const snapshot = await get(newRef);

    if (!snapshot.exists()) {
      console.log("No data found");
      return [];
    }

    const allData = Object.values(snapshot.val());

    // Date for 6 months ago
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

    // Filter entries by created_at
    const filteredData = allData.filter((entry) => {
      if (!entry.created_at) return false;

      // Add 'Z' to treat it as UTC (or use new Date(... + "Z"))
      const createdAtDate = new Date(entry.created_at + "Z");

      return createdAtDate >= sixMonthsAgo;
    });

    return filteredData;
  };

  // get set goal 
  const { data: setGoal, isLoading: setGoalLoading, error: setGoalError, refetch: refetchSetGoal } = useQuery({ 
    queryKey: ["get-set-goal"],
    queryFn: () => getSetGoal(auth?.token),
    enabled: !!auth?.token,
  });

  const hasSetGoal = setGoal?.data?.data?.hasSetEnergyGoal || false

  const { data, Loading, error } = useQuery({
    queryKey: ["energy-sharing-data"],
    queryFn: getFireBaseData,
    enabled: !!deviceId,
  });

  const {
    data: historicalData,
    isLoading: historicalLoading,
    error: historicalError
  } = useQuery({
    queryKey: ["historical-baseline", auth?.token],
    queryFn: () => getHistoricalBaseLine(auth?.token),
    enabled: !! auth?.token,
  });

  const baseline = historicalData?.data?.data;
console.log("BASELINE-DATA", historicalData)
  // Use energy insights hook
  const energyInsights = useEnergyInsights(
    data || [],
    setGoal?.data?.data?.energyGoalKw || 0,
    baseline?.baselineKw || 0,
    6
  );

  console.log(baseline)
  console.log("Energy Insights:", energyInsights)

  const getTodayData = (data) => {
    if (!Array.isArray(data)) return [];

    const today = new Date();
    const todayDateString = today.toISOString().split("T")[0];

    return data.filter(item => {
      if (!item?.createdAt) return false;

      const itemDate = new Date(item.createdAt);
      const itemDateString = itemDate.toISOString().split("T")[0];

      return itemDateString === todayDateString;
    });
  };

  const todayUsage = getTodayData(data);
  console.log(todayUsage)

  useEffect(()=>{
    getDeviceId();
  }, [auth?.userInfo?.id, auth?.token])

  // Updated submit function with blockchain integration
  // const submit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   setApiError(null);
  //   setSuccessMessage('');
  //   setBlockchainTxHash(null);
    
  //   try {
  //     // Validate input
  //     const goalValue = parseFloat(energyGoalKw);
  //     if (isNaN(goalValue) || goalValue <= 0) {
  //       throw new Error("Please enter a valid positive number for energy goal");
  //     }

  //     // Check if wallet is connected
  //     if (!signer) {
  //       throw new Error("Please connect your wallet first");
  //     }

  //     console.log("Submitting energy goal:", goalValue);
  //     console.log("Signer available:", !!signer);

  //     // Step 1: Set energy goal on blockchain first
  //     let blockchainResult;
  //     try {
  //       console.log("Setting goal on blockchain...");
  //       blockchainResult = await setEnergyGoalBlockchain(goalValue, signer);
  //       console.log("Blockchain transaction successful:", blockchainResult);
  //       setBlockchainTxHash(blockchainResult.transactionHash);
  //     } catch (blockchainError) {
  //       console.error("Blockchain transaction failed:", blockchainError);
  //       throw new Error(`Blockchain transaction failed: ${blockchainError.message}`);
  //     }

  //     // Step 2: If blockchain transaction successful, save to backend
  //     try {
  //       console.log("Saving to backend...");
  //       const backendResponse = await setEnergyGoalAPI(goalValue, auth?.token, auth?.userInfo?.id);
  //       console.log("Backend API success:", backendResponse.data);
        
  //       setShowSuccess(true);
  //       setShowGoalModal(false);
  //       setSuccessMessage(`Energy goal set successfully! Transaction Hash: ${blockchainResult.transactionHash}`);
        
  //       // Clear the form
  //       setEnergyGoalValue('');
        
  //       // Refetch the goal data to update the UI
  //       refetchSetGoal();
        
  //     } catch (backendError) {
  //       console.error("Backend API failed:", backendError);
  //       // Even if backend fails, we have blockchain record
  //       setSuccessMessage(`Goal set on blockchain (${blockchainResult.transactionHash}) but backend sync failed. Please try again or contact support.`);
  //       setShowGoalModal(false);
  //       setEnergyGoalValue('');
  //     }

  //   } catch (error) {
  //     console.error("Error setting energy goal:", error);
  //     setApiError(error.message || "Failed to set energy goal");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  const submit = async()=>{
    // e.preventDefault()
    try {
      // Validate input
      const goalValue = parseFloat(energyGoalKw);
      if (isNaN(goalValue) || goalValue <= 0) {
        throw new Error("Please enter a valid positive number for energy goal");
      }

      // Check if wallet is connected
      if (!signer) {
        throw new Error("Please connect your wallet first");
      }

      console.log("Submitting energy goal:", goalValue);
      console.log("Signer available:", !!signer);

      // Step 1: Set energy goal on blockchain first
      let blockchainResult;
      try {
        console.log("Setting goal on blockchain...");
        blockchainResult = await setEnergyGoalBlockchain(goalValue, signer);
        console.log("Blockchain transaction successful:", blockchainResult);
        setBlockchainTxHash(blockchainResult.transactionHash);
      } catch (blockchainError) {
        console.error("Blockchain transaction failed:", blockchainError);
        throw new Error(`Blockchain transaction failed: ${blockchainError.message}`);
      }

      // Step 2: If blockchain transaction successful, save to backend
      try {
        console.log("Saving to backend...");
        const backendResponse = await setEnergyGoalAPI(goalValue, auth?.token, auth?.userInfo?.id);
        console.log("Backend API success:", backendResponse.data);
        
        setShowSuccess(true);
        setShowGoalModal(false);
        setSuccessMessage(`Energy goal set successfully! Transaction Hash: ${blockchainResult.transactionHash}`);
        
        // Clear the form
        setEnergyGoalValue('');
        
        // Refetch the goal data to update the UI
        refetchSetGoal();
        
      } catch (backendError) {
        console.error("Backend API failed:", backendError);
        // Even if backend fails, we have blockchain record
        setSuccessMessage(`Goal set on blockchain (${blockchainResult.transactionHash}) but backend sync failed. Please try again `);
        setShowGoalModal(false);
        setEnergyGoalValue('');
      }

    } catch (error) {
      console.log(error)
      
    }
  }

  const amountLeft = Math.max(0, (setGoal?.data?.data?.energyGoalKw || 0) - energyInsights.energyMeterUsage)

  useEffect(() => {
    if (chartRef.current) {
      // Initialize the chart
      const myChart = echarts.init(chartRef.current);
  
      const goalValue = setGoal?.data?.data?.energyGoalKw || 0;
      const currentUsage = energyInsights.energyMeterUsage;
      const max = goalValue > 0 ? goalValue : 100;
      const progressPercent = goalValue > 0 ? Math.min(currentUsage / max, 1) : 0; // Cap at 100%
      
      // Determine chart color based on usage vs goal
      const isOverGoal = currentUsage > goalValue && goalValue > 0;
      const chartColor = isOverGoal ? 'red' : 'green';
      
      // Calculate months left
      const monthsLeft = energyInsights.energyMeterMonthsLeft;

      const option = {
        series: [
          {
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: max,
            splitNumber: 1,
            radius: '100%',
            center: ['50%', '90%'],
            clockwise: true, // Move clockwise
            axisLine: {
              lineStyle: {
                width: 18,
                color: [
                  [progressPercent, chartColor], // filled (red if over goal, green if under)
                  [1, 'rgba(228, 231, 236, 1)'] // unfilled (light gray)
                ]
              }
            },
            pointer: {
              show: false
            },
            progress: {
              show: true,
              width: 18,
              itemStyle: {
                color: chartColor
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              show: true,
              formatter: `${(progressPercent * 100).toFixed(1)}%\n${monthsLeft.toFixed(1)} months left`,
              fontSize: 12,
              color: '#666',
              offsetCenter: [0, '60%'],
              lineHeight: 16
            },
            data: [
              {
                value: currentUsage
              }
            ]
          }
        ]
      };

      myChart.setOption(option);
      // Cleanup on unmount
      return () => {
        myChart.dispose();
      };
    }
  }, [setGoal?.data?.data?.energyGoalKw, energyInsights.energyMeterUsage, energyInsights.energyMeterUsage > (setGoal?.data?.data?.energyGoalKw || 0)]);

  return (
    <div className='efficiencyCard'>

      <div className='rounded-lg bg-white flex gap-5 w-full '>

      {/* Historical Baseline */}

        <div className='   border border-gray-200 p-10 rounded-[12px] h-[210px] w-[500px]'>
          <div className='flex gap-[250px]  '>
          <div className='text-[16px] text-gray-400 '>Historical Baseline</div>
          <div className='  ' >
          <Link to={"/efficiency-baseline-tables"} className='' >

            <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg" >
<path d="M2 3.25C2.41421 3.25 2.75 2.91421 2.75 2.5C2.75 2.08579 2.41421 1.75 2 1.75C1.58579 1.75 1.25 2.08579 1.25 2.5C1.25 2.91421 1.58579 3.25 2 3.25Z" stroke="#101828" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 8.75C2.41421 8.75 2.75 8.41421 2.75 8C2.75 7.58579 2.41421 7.25 2 7.25C1.58579 7.25 1.25 7.58579 1.25 8C1.25 8.41421 1.58579 8.75 2 8.75Z" stroke="#101828" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 14.25C2.41421 14.25 2.75 13.9142 2.75 13.5C2.75 13.0858 2.41421 12.75 2 12.75C1.58579 12.75 1.25 13.0858 1.25 13.5C1.25 13.9142 1.58579 14.25 2 14.25Z" stroke="#101828" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
          </Link>

</div>

</div>
<div className='text-[24px] font-semibold mt-10'>
  <p> {baseline?.baselineKw || "0"} kw</p>
        </div>

        <hr className='border-gray-200 w-full mb-22 mt-8' />
        <div className='text-gray-400 text-lg mt-5'>No baseline history yet...</div>
        </div>
        
        {/* Energy Goal */}
{
  !hasSetGoal ? (
   <div className="flex-1 flex flex-col justify-between border border-gray-200 rounded-[12px] p-8 bg-white h-[210px] max-w-[500px] ">
          <div>
            <div className="text-2xl font-medium text-gray-600 mb-8">Energy Goal</div>
            <button  className="w-full flex items-center justify-center gap-[12px] bg-[#2C9963] hover:bg-green-700 text-white text-xl font-medium py-5 rounded-full transition-colors" onClick={() => {setShowGoalModal(true);
              // connectWallet()
              ;}
            }>
              Set Energy goal
              <span className="inline-flex items-center justify-center w-8 h-8 border border-white rounded-full">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 8V16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M8 12H16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
            </button>
          </div>
          <hr className='border-gray-200 w-full mb-5 mt-5' />
          <div className=" text-gray-400 text-lg ">
            Set your energy goal to begin the use of energy efficiency.
          </div>
        </div>
     ) : (
        // Show goal details when hasSetGoal is true
        <div className="flex-1 flex flex-col justify-between border border-gray-200 rounded-[12px] p-8 bg-white h-[210px] w-[400px] mx-2 ">
          <div>
            <div className="text-2xl  text-gray-400 mb-8">Energy Goal</div>
            <div className="text-3xl font-bold ">
              {setGoal?.data?.data?.energyGoalKw || 0} kW
            </div>
          </div>
          <hr className='border-gray-200 w-full  mt-8' />
          <div className="mt-4 text-gray-400 text-lg ">
            Your energy goal has been set successfully.
          </div>
        </div>
     )
}

{/* Energy Meter */}

<div className="energy-meter-card border  border-gray-200 rounded-[12px] h-[210px] max-w-[500px] white relative pr-20" >
  <div className="flex items-center p-4">
    <span className="text-[#666C85] text-[16px] font-medium ml-[20px] mt-[20px] absolute  left-0">Energy Meter</span>
    <div>
      <button  className='ml-[300px] mt-[20px]' >
        <Link to={"/efficiency-report"}>
      <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 3.25C2.41421 3.25 2.75 2.91421 2.75 2.5C2.75 2.08579 2.41421 1.75 2 1.75C1.58579 1.75 1.25 2.08579 1.25 2.5C1.25 2.91421 1.58579 3.25 2 3.25Z" stroke="#101828" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 8.75C2.41421 8.75 2.75 8.41421 2.75 8C2.75 7.58579 2.41421 7.25 2 7.25C1.58579 7.25 1.25 7.58579 1.25 8C1.25 8.41421 1.58579 8.75 2 8.75Z" stroke="#101828" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 14.25C2.41421 14.25 2.75 13.9142 2.75 13.5C2.75 13.0858 2.41421 12.75 2 12.75C1.58579 12.75 1.25 13.0858 1.25 13.5C1.25 13.9142 1.58579 14.25 2 14.25Z" stroke="#101828" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        </Link>

      </button>
    </div>
  </div>
  <div className="flex flex-col items-center p-4  " style={{ position: 'relative' }}>
    <div style={{ position: 'relative', width: 100, height: 100, marginBottom: 8,marginLeft:50}}>
      <div ref={chartRef} style={{ width: 164, height: 164, position: 'absolute', top: -80, right: -30, }} />
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '50%',
        transform: 'translate(-50%, 0)',
        fontWeight: 700,
        fontSize: 18,
        color: '#222',
        textAlign: 'center',
        pointerEvents: 'none',
        width: '100%',
      }}>
        {energyInsights.energyMeterMonthsLeft}</div>
     <div style={{
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, 0)',
        fontWeight: 700,
        fontSize: 8,
        color: 'Grey',
        textAlign: 'center',
        pointerEvents: 'none',
        width: '100%'}}>months left</div>
    </div>

    <div className="flex ml-[50px] gap-44 -mt-10">
      <div className="text-center">
        <div className="font-bold text-[12px]">{energyInsights.energyMeterUsage}<span className=""> kWh</span></div>
        <div className="text-gray-400 text-[8px]">Usage</div>
      </div>
      <div className="text-center">
        <div className="font-bold text-[12px]">{setGoal?.data?.data?.energyGoalKw || 0}<span className=""> kWh</span></div>
        <div className="text-gray-400 text-[8px]">Energy goal</div>
      </div>
    </div>
  </div>
</div>
      </div>

      {/* energy insights */}

      <div className='mt-10   '>
        <h1 className='text-[16px] mb-5 font-semibold'>Energy Insights</h1>

        <div className='flex gap-10 w-full '>

          <div className='flex items-center gap-14 border border-gray-200 pb-10 pr-10 pl-10 pt-5  rounded-[12px] h-[120px]'>
            <div className=''>
          {energyInsights.energySavedPercentage > 0 ? (
            <>
          <h1 className='text-2xl font-semibold mb-3 p-5'> You've saved</h1>

            <h1 className=' text-3xl font-bold'>{energyInsights.energySavedPercentage}%</h1>
            </>

          ) : (
            <>
          <h1 className='text-2xl font-semibold mt-3 p-5'> You've saved</h1>

            <h1 className='text-gray-500 text-xl'>Once you start saving<br></br> energy it will be displayed <br></br> on this card</h1>
            </>

          )}
          
          </div>
          <div>
            {/* energy insight svg as background */}
            <div style={{ position: 'relative', width: 120, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg
                width="120"
                height="120"
                viewBox="0 0 123 99"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ position: 'absolute', top: 0, left: 0, zIndex: 0 }}
              >
                <g filter="url(#filter0_f_6129_64503)">
                  <circle cx="64" cy="64" r="38" fill="#038B47" fillOpacity="0.2" />
                </g>
                <defs>
                  <filter id="filter0_f_6129_64503" x="0.857141" y="0.857141" width="126.286" height="126.286" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="12.5714" result="effect1_foregroundBlur_6129_64503" />
                  </filter>
                </defs>
              </svg>
              <img src={battery} alt="Energy Battery" style={{ position: 'relative', zIndex: 1, width: 80, height: 'auto' }} />
            </div>
          </div>

          </div>

          {/* Today's usage */}
          
          <div className='flex items-center gap-2 border border-gray-200 pr-28 pt-5 pb-5 pl-5 rounded-[12px] h-[120px]'>
            <div className='ml-8'>
          <h1 className='text-2xl font-semibold mb-5 mt-3'> Today's usage</h1>
          {energyInsights.todayUsage > 0 ? (
            <div>
              <div className='font-bold text-[18px]'>
                {energyInsights.todayUsage} kWh
              </div>
              {energyInsights.todayVsYesterdayPercentage !== 0 && (
                <div className={`text-sm ${energyInsights.todayVsYesterdayPercentage > 0 ? 'text-red-500' : 'text-green-500'}`}>
                  {energyInsights.todayVsYesterdayPercentage > 0 ? '+' : ''}{energyInsights.todayVsYesterdayPercentage}% vs yesterday
                </div>
              )}
            </div>
          ) : (
            <h1 className='text-gray-500 text-xl'>Set up an energy goal to <br></br> start tracking your energy <br></br>usage</h1>
          )}

          </div>

          </div>

          {/* Peak usage time */}
          
          <div className='flex items-center gap-2 border border-gray-200 pr-28 rounded-[12px] h-[120px] pt-5 pb-5 pl-5'>
            <div className='ml-8 mt-3' >
          <h1 className='text-2xl font-semibold mb-5'> Peak usage time</h1>
          {energyInsights.peakUsageTime !== "N/A" ? (
            <div>
              <div className='font-bold text-[18px]'>
                {energyInsights.peakUsageTime}
              </div>
              <div className='text-sm text-gray-500'>
                {energyInsights.peakUsageValue} kWh
              </div>
            </div>
          ) : (
            <h1 className='text-gray-500 text-xl'>Set up an energy goal to<br></br>start tracking your peak <br></br>usage time</h1>
          )}
          
          </div>
          <div>
           
          </div>

          </div>

          {/* Goal tracker */}
          <div className='flex items-center gap-2 border border-gray-200 pr-32 rounded-[12px] h-[120px] pt-5 pb-5 pl-5'>
            <div className='ml-8 mt-3'>
          <h1 className='text-2xl font-semibold mb-5'>Goal tracker</h1>
          {energyInsights.goalTrackerValue > 0 ? (
            <div>
              <div className='font-bold text-[18px]'>
                {energyInsights.goalTrackerValue} kWh
              </div>
              <div className={`text-sm ${energyInsights.goalTrackerPercentage > 0 ? 'text-red-500' : 'text-green-500'}`}>
                {energyInsights.goalTrackerPercentage > 0 ? '+' : ''}{energyInsights.goalTrackerPercentage}% vs last week
              </div>
            </div>
          ) : (
            <h1 className='text-gray-500 text-xl'>Set up an energy goal to<br></br> create an energy goal </h1>
          )}
          
          </div>
          <div>
          
          </div>

          </div>

        </div>

      </div>
      
      {/* Modal Overlay for Setting Energy Goal */}
      {showGoalModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-xl shadow-lg p-10 h-[450px] w-[512px] relative">
            <button
              className="absolute top-4 right-4 text-gray-400 w-10 hover:text-red-500 text-3xl font-bold"
              onClick={() => setShowGoalModal(false)}
              aria-label="Close"
            >
              &times;
            </button>
            <h2 className="text-[24px] font-semibold mb-2">Set energy goal</h2>
            <p className="text-[14px] text-gray-500 mb-6">Provide this information to set your goal.</p>
            


            <form onSubmit={submit}>
              <div className="mb-4">
                <label className="block text-[16px] text-gray-700 mb-2">Energy goal</label>
                <input
                  type="number"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Input energy goal (kW)"
                  value={energyGoalKw}
                  onChange={e => setEnergyGoalValue(e.target.value)}
                  // min="0"
                  // step="0.01"
                  required
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 text-[16px] mb-2">Duration (6 months to reach your goal)</label>
                <div className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500">
                  6 months
                </div>
              </div>
{/*               
              {apiError && (
                <div className="text-red-500 mb-4 p-2 bg-red-50 border border-red-200 rounded">
                  {apiError}
                </div>
              )} */}
{/*               
              {successMessage && (
                <div className="text-green-500 mb-4 p-2 bg-green-50 border border-green-200 rounded text-sm">
                  {successMessage}
                </div>
              )} */}
{/* 
              {blockchainTxHash && (
                <div className="mb-4 p-2 bg-blue-50 border border-blue-200 rounded">
                  <p className="text-sm text-blue-800">
                    Blockchain Transaction: 
                    <a 
                      href={`https://sepolia-optimism.etherscan.io/tx/${blockchainTxHash}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="ml-1 underline hover:text-blue-600"
                    >
                      {blockchainTxHash.slice(0, 10)}...
                    </a>
                  </p>
                </div>
              )} */}
              
              <button
                type='submit'
                className="w-full bg-gradient-to-r from-green-500 to-teal-400 hover:from-green-600 hover:to-teal-500 text-white text-2xl font-semibold py-4 rounded-lg transition-colors disabled:opacity-60"
                // disabled={isLoading}
              >
                {isLoading ? 'Setting Goal...' : 'Set Goal'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default EfficiencyCard